namespace Matrix.Administration {
    export interface RunBookListRequest extends Serenity.ServiceRequest {
        StepId?: number;
    }
}
